import React from "react";
import "./index.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Admin from "./pages/Admin/Admin";
import { Route, Routes, Navigate } from "react-router-dom";
import { HomeScreen } from "./pages/Home";
import ProdutosPage from "./pages/Produtos/ProdutosPage"; // página de detalhe
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Header />
      <Routes>
        {/* Redireciona a rota raiz para /home */}
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<HomeScreen />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/produtos/:id" element={<ProdutosPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
